import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { LoadingShimmerComponent } from '../../../loading-shimmer/loading-shimmer.component';
import { TooltipDirective } from '../../../../directives/tooltip.directive';

@Component({
  selector: 'lib-icon-table-cell',
  imports: [MatIcon, LoadingShimmerComponent, TooltipDirective],
  templateUrl: './icon-table-cell.component.html',
  styleUrl: './icon-table-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconTableCellComponent {
  iconName = input.required<string>();
  loading = input.required<boolean>();
  iconToolTip = input<string>();
  iconClicked = input<() => void>();

  handleClick() {
    if (this.iconClicked()) {
      this.iconClicked()?.();
    }
  }
}
